import { fieldsDefined } from "../CustomerSheet/utils";
import { ClientUpdateInput } from "@lhd/types";

export const columns = (displaySize?: "small" | "medium" | "large") => {
  return [
    {
      headerName: "",
      field: "index",
      minWidth: 60,
      maxWidth: 60,
      filter: false,
      sortable: false,
      pinned: "left",
      cellRenderer: (params: any) => {
        const currentPage = params?.data?.page;
        const pageSize = params?.data?.pageSize;
        const rowIndex = (currentPage - 1) * pageSize + params.rowIndex + 1;
        return rowIndex;
      },
    },
    {
      headerName: "",
      field: "isChecked",
      minWidth: 150,
      width: 150,
      pinned: "left",
      cellStyle: { textAlign: "center", justifyContent: "center" },
      filter: false,
      sortable: false,
    },
    {
      headerName: "企業名（事業所名）",
      field: fieldsDefined.client_name_name,
      minWidth: 200,
      pinned: "left",
      headerWithFilter: true,
      floatingFilter: false,
      filter: false,
      sortable: false,
    },
    {
      headerName: "会社形態",
      field: fieldsDefined.client_name_company_type,
      minWidth: 140,
      pinned: "left",
      headerWithFilter: true,
      floatingFilter: false,
      filter: false,
      sortable: false,
    },
    {
      headerName: "前後",
      field: fieldsDefined.client_name_show_company_type,
      minWidth: 140,
      pinned: "left",
      headerWithFilter: true,
      floatingFilter: false,
      filter: false,
      sortable: false,
    },
    {
      headerName: "開始日",
      field: fieldsDefined.client_name_start_date,
      minWidth: 140,
      pinned: "left",
      headerWithFilter: true,
      floatingFilter: false,
      filter: false,
      sortable: false,
    },
  ];
};

export const WIDTH_OPERATOR = {
  small: 190,
  medium: 200,
  large: 220,
};

export const getCustomerName = (customer: ClientUpdateInput | any) => {
  switch (customer?.client_name?.show_company_type) {
    case "before":
      return `${customer?.client_name?.company_type || ""} ${
        customer?.client_name?.name || ""
      }`;
    case "after":
      return `${customer?.client_name?.name || ""} ${
        customer?.client_name?.company_type || ""
      }`;
    default:
      return customer?.client_name?.name || customer?.name || "";
  }
};
